import { SupportedLanguage } from '../config/constants/supportedLanguage.enum';
export default class SupportLanguageHelper {
    public static getSupportLanguage(language: string | SupportedLanguage): SupportedLanguage {
        const allLangs = Object.values(SupportedLanguage) as string[];
        if (allLangs.includes(language)) {
            return language as SupportedLanguage;
        }
        return SupportedLanguage.EN;
    }
}
